import axios from 'axios';

export default {
  namespaced: true,
  state: {

  },
  mutations: {
  },
  actions: {
    addWxPay({ commit }, params) {
      return axios.post('/wxnews/ajax/addWxPay', params)
        .then((data) => {
          return data;
        });
    },
    updateWxPay({ commit }, params) {
      return axios.post('/wxnews/ajax/updateWxPay', params)
        .then((data) => {
          return data;
        });
    },
    getByAppId({ commit }, params) {
      return axios.get('/wxnews/ajax/getByAppId', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    // 新接口 20190219
    addSubMerchant({ commit }, params) {
      return axios.post('/wxnews/ajax/addSubMerchant', params)
        .then((data) => {
          return data;
        });
    },
    updateSubMerchant({ commit }, params) {
      return axios.post('/wxnews/ajax/updateSubMerchant', params)
        .then((data) => {
          return data;
        });
    },
    getSubMerchantList({ commit }, params) {
      return axios.get('/wxnews/ajax/getSubMerchantList', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    addMerchantPayConfig({ commit }, params) {
      return axios.post('/wxnews/ajax/addMerchantPayConfig', params)
        .then((data) => {
          return data;
        });
    },
    updateMerchantPayConfig({ commit }, params) {
      return axios.post('/wxnews/ajax/updateMerchantPayConfig', params)
        .then((data) => {
          return data;
        });
    },
    getAppPayConfigList({ commit }, params) {
      return axios.get('/wxnews/ajax/getAppPayConfigList', {
        params: params,
      }).then((data) => {
        return data;
      });
    }
  }
};
